import { memo, useRef } from 'react'

import { Input } from 'components'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import * as S from './styles'

interface ItemSizeProps {
  colorName: string
  size: string
  disabled?: boolean
}

function ItemSize({ colorName, size, disabled }: ItemSizeProps) {
  return (
    <>
      <MyInput colorName={colorName} disabled={disabled} size={size} />
    </>
  )
}

export default ItemSize

const MyInput = memo(function MyInput({ colorName, size, disabled }: ItemSizeProps) {
  const { control } = useFormContext()
  const inputRef = useRef<HTMLInputElement>(null)

  const [watchedMixedBox, watchedQtdMixedBox] = useWatch({
    control: control,
    name: ['fl_caix_grad', 'qt_caix_grad'],
  })

  return (
    <>
      <Controller
        control={control}
        defaultValue=""
        name={`[${colorName}].${size}`}
        render={({ field: { name, onChange, value }, fieldState: { invalid } }) => {
          const convertedValue =
            watchedMixedBox && value ? `(${value * Number(watchedQtdMixedBox)})` : 1
          return (
            <>
              <Input
                browserAutocomplete="off"
                disabled={disabled}
                errorOutline={invalid}
                height={30}
                InputProps={{
                  inputProps: { maxLength: 6 },
                }}
                id={`input-amount-${colorName.toLowerCase()}-${size}`}
                maxLength={watchedMixedBox ? 2 : 6}
                name={name}
                onChange={(e) => {
                  const currentValue = e.target.value.replace(/\D/, '')
                  const parsedCurrentValue = currentValue ? parseInt(currentValue) : 0
                  onChange(parsedCurrentValue)
                }}
                ref={inputRef}
                value={value || ''}
                width={80}
              />
              {!!value && watchedMixedBox && (
                <S.MixedBoxValue onClick={() => inputRef.current?.focus()}>
                  {convertedValue}
                </S.MixedBoxValue>
              )}
            </>
          )
        }}
      />
    </>
  )
})
